import Link from "next/link";
import styles from "./styles.module.scss";
import { PortableText } from "@portabletext/react";
import { IconRenderer } from "@/components/IconRenderer";
import { urlFor } from "@/sanity/lib/image";
import { portableTextComponents } from "@/lib/portableTextComponents";

export function Features({ title, subtitle, features, iconSize = '48px' }) {

  return (
    <section className={styles.features}>
      {title && <h2 className={styles.title}>{title}</h2>}

      {subtitle && (
        <div className={styles.subtitle}>
          <PortableText components={portableTextComponents} value={subtitle} />
        </div>
      )}

      {Array.isArray(features) && (
        <div className={styles.grid}>
          {features.map((feature) => {
            const isInternal = feature.link?.startsWith("/");
            const content = (
              <>
                {feature.mediaType === "icon" && feature.icon && (
                  <IconRenderer icon={feature.icon} className={styles.icon} style={{ width: iconSize, height: iconSize }} />
                )}

                {feature.mediaType === "image" && feature.media?.asset && (
                  <img
                    src={urlFor(feature.media.asset).url()}
                    alt={feature.title || ""}
                    className={styles.image}
                    style={feature.maxWidth ? { maxWidth: feature.maxWidth } : undefined}
                  />
                )}

                {feature.title && (
                  <h2 className={styles.featureTitle}>{feature.title}</h2>
                )}

                {feature.text && (
                  <div className={styles.featureText}>
                    <PortableText components={portableTextComponents} value={feature.text} />
                  </div>
                )}
              </>
            );

            const wrapperClass = [
              styles.feature,
              feature.horizontalAlign && styles[feature.horizontalAlign],
              feature.verticalAlign && styles[`vertical-${feature.verticalAlign}`],
              feature.link && styles.link,
            ]
              .filter(Boolean)
              .join(" ");

            if (feature.link) {
              return isInternal ? (
                <Link key={feature._key} href={feature.link} className={wrapperClass}>
                  {content}
                </Link>
              ) : (
                <a
                  key={feature._key}
                  href={feature.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={wrapperClass}
                >
                  {content}
                </a>
              );
            }

            return (
              <div key={feature._key} className={wrapperClass}>
                {content}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
